import { jsx } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { Fragment, forwardRef } from "react";
import { useSlotProps } from "../../base/index.js";
import { AlertSnack } from "../AlertSnack/index.js";
import { Root } from "./components/Root.js";
import { snackMachineName } from "./classes.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const defaultOrigin = {
  vertical: "bottom",
  horizontal: "right"
};
const SnackMachine = forwardRef(
  SnackMachineComponent
);
function SnackMachineComponent(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: snackMachineName
  });
  const {
    sx,
    width = "320px",
    testId = "tidal-snackmachine",
    variant = "standard",
    anchorOrigin = defaultOrigin,
    snackMachine,
    snackComponent: Snack = AlertSnack,
    componentsProps
  } = props;
  const externalForwardedProps = {
    sx
  };
  const ownerState = {
    ...props,
    width,
    anchorOrigin
  };
  const snacks = snackMachine.useSnacks();
  const utilityClasses = useUtilityClasses(props);
  const rootSlotProps = useSlotProps({
    ownerState,
    elementType: Root,
    externalForwardedProps,
    className: utilityClasses.root,
    externalSlotProps: componentsProps?.root,
    additionalProps: {
      ref,
      "data-testid": testId,
      "data-tidal": "SnackMachine"
    }
  });
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children: snacks.map((snack) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Snack,
    {
      snack,
      variant,
      anchorOrigin,
      snackMachine
    }
  ) }, snack.id)) });
}
export {
  SnackMachine
};
//# sourceMappingURL=SnackMachine.js.map
